import React, { Component } from 'react';
import Repository from '../../shared/repository';
import constraints  from '../../../../config/constants.json';

const contractId=constraints.ContractId

class AhcRepository extends Component {
  constructor() {
    super();
    this.state = {}
  }

  render() {
    return (
      <Repository
        contractId={ContractId.AHC}
      />
    );
  }
}

export default AhcRepository;
